import { render, staticRenderFns } from "./DirectFlightFilterHotel.vue?vue&type=template&id=507be0b0"
import script from "./DirectFlightFilterHotel.vue?vue&type=script&lang=ts"
export * from "./DirectFlightFilterHotel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports